import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GCValidators } from '../../shared/validators/gc-validator';
import { SupportService } from '../../shared/services/support.service';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {

  result: string;

  constructor(private support:SupportService,
              private snackBar: MatSnackBar,
              private translate: TranslateService){

  }

  supportForm = new FormGroup({
    subject: new FormControl('', [Validators.required, Validators.minLength(2)]),
    message: new FormControl('', [Validators.required, Validators.minLength(2)]),
  });
  
  ngOnInit() {
  }

  submitSupportForm(e){
    e.preventDefault();

    if (this.supportForm.valid){
      this.support.sendSupportMessage(this.supportForm.value.subject, this.supportForm.value.message)
      .then(result => {
        this.translate.get('SUPPORT.ALERT.sentSuccess').subscribe((message: string) => {
          let snackBarRef = this.snackBar.open(message, null, {verticalPosition: 'top', duration: 4000, panelClass: ['b2a-success','top']})
        })

        this.result = "SUPPORT.sentSuccessMsg";
      })
      .catch(error => {
        this.translate.get('SUPPORT.ALERT.sentError').subscribe((message: string) => {
          let snackBarRef = this.snackBar.open(message, null, {verticalPosition: 'top', duration: 4000, panelClass: ['b2a-error','top']})
        })
      })
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/support/support.component.ts